/* @flow */
import React from 'react'
import { Translate } from 'react-redux-i18n'
import { FaChevronUp, FaChevronDown } from 'react-icons/lib/fa'

import './style.css'

class Header extends React.PureComponent {
  state = {
    isOpen: false
  }

  render() {
    const { size, onClick, togglable, circle, title, comment } = this.props
    const { isOpen} = this.state

    return (
      <div className={'header ' + (size || 'md')} onClick={(e) => {
        onClick && onClick(e)
        if (togglable) {
          this.setState({ isOpen: !isOpen })
        }
      }}>
        <div className="lead">
          <i className={'icon icon-circle-' + (circle || 'g')}>
            <span className="path1"></span><span className="path2"></span>          
          </i>
          <Translate value={title} className="headline" />
          { comment ? <Translate value={comment} className="comment" /> : null }
        </div>
        <div className="icon-right">
        {
          togglable ?
          (
            isOpen ?
              <FaChevronUp size={20} color="#656464" /> :
              <FaChevronDown size={20} color="#656464" />
          ) :
          null
        }
        </div>
      </div>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/Header/index.js